import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { AppService } from '../app.service';
import { AuthService } from '../_core/auth.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';

import * as _ from 'lodash';
import moment from 'moment';
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OrderLoyaltyService {

	appConfig = environment.appConfig;

	loyaltyData: any = null;
	loyaltyClub: any = null;
	loyaltyMember: any = null;
	customer: any = null;
	loyaltyOffers: any = null;
	active: boolean = false;


	maxBirthdayDate: Date = moment().subtract(10, 'years').startOf('year').toDate();
	minBirthdayDate: Date = moment().subtract(90, 'years').startOf('year').toDate();
	maxAnniversary: Date = moment().subtract(1, 'days').toDate();
	minAnniversary: Date = moment().subtract(60, 'years').startOf('year').toDate();

	tdServiceTypeMap = {
		"eatin": "seated",
		"takeaway": "takeaway"
	}

	constructor(
		private httpClient: HttpClient,
		private appService: AppService,
		private orderService: OrderService,
		private orderUtils: OrderItemsUtilsService,
		private authService: AuthService,
	) {
		this.active = this.appConfig.tabitLoyaltyAPI != null;

	}

	init() {
		this.loyaltyData = null;
		this.customer = null;
		this.loyaltyMember = null;
		this.appService.$storage.hasLoyalty = null;
		this.orderService.$storage.loyalty = {};
		this.orderService.cacheOrder();
	}

	cacheLoyalty() {
		this.orderService.$storage.loyalty = {
			loyaltyData: this.loyaltyData,
			customer: this.customer,
			loyaltyMember: this.loyaltyMember,
			loyaltyClub: this.loyaltyClub
		};
		this.orderService.cacheOrder();
	}

	restoreLoyalty() {
		let $storage = this.orderService.$storage;
		this.loyaltyData = $storage.loyalty.loyaltyData;
		this.customer = $storage.loyalty.customer;
		this.loyaltyMember = $storage.loyalty.loyaltyMember;
		this.loyaltyClub = $storage.loyalty.loyaltyClub;
	}

	autoLoginSignOut($storage) {
		if ($storage.wasLoyaltyAutoLogin) this.signOut($storage);
	}
	async getCustomerAutoLogin($storage: any) {
		if (!this.appService.user || !this.appService.regionArgs.enableAutoLoyaltyLogin) return;
		try {
			let res: any = await this.postCustomerAutoLogin(this.appService.getOrganization());
			if (res.IsSuccess) {
				$storage.wasLoyaltyAutoLogin = true;
				const accountGuid = res.ResponseData?.configurations?.accountGuid?.toLowerCase();
				let loyaltyClub = $storage.loyaltyClubs.find(o => o.accountGuid?.toLowerCase() == accountGuid);
				if (loyaltyClub) {
					this.loyaltyClub = loyaltyClub;
					this.prepareLoyaltyLoginResponse($storage, res);
					return res;
				} else {
					return null;
				}
			} else {
				return null;
			}
		} catch (e) {
			return null;
		}
	}

	async postCustomerAutoLogin(siteId: string) {
		let headers = {
			headers: new HttpHeaders({
				'Authorization': `Bearer ${localStorage.getItem('loyaltyToken')}`,
				'env': this.appConfig.loyaltyEnv ,
				'JoinChannelGuid': this.appConfig.loyaltyJoinChannelGUID,
				'siteId': siteId
			})
		}
		return  firstValueFrom(this.httpClient.get(`${this.appConfig.tabitLoyaltyAPI}/pos/get-customer-auto-login`, headers));
	}

	// ----------------------------------------------------------------------------------------------------------->
	// API
	// ----------------------------------------------------------------------------------------------------------->

	fixResponseObject(obj) {
		if (!obj) return {}
		_.each(obj, (val, key) => {
			if (val == "") obj[key] = undefined;
		});
		return obj;
	}

	checkPhone(payload) {
		return this.post('/pos/otp-manager', payload).then(res => {
			return res;
		}).catch(err => {
			throw (err);
		});
	}

	prepareRegistrationPayload(payload) {
		let res = _.assignIn({}, payload);
		if (res.birthDate) { res.birthDate = moment(res.birthDate).format('YYYY-MM-DDT00:00:00') }
		if (res.anniversary) { res.anniversary = moment(res.anniversary).format('YYYY-MM-DDT00:00:00') }
		return res;
	}

	register($storage, loyaltyClub, payload) {
		this.loyaltyClub = loyaltyClub;
		return this.post('/pos/register-customer', this.prepareRegistrationPayload(payload)).then(res => {
			//return this.post('/pos/send-invitation', payload).then(res => {
			if (res.IsSuccess) {
				this.prepareLoyaltyLoginResponse($storage, res);
			} else {
				throw ({
					message: res.Message
				});
			}

		}).catch(err => {
			console.error(err);
			let message;// = _.get(err, 'error.Message', err.message);
			if (err.type) message = err.message;
			this.appService.alert({ content: message || '_LOYALTY_REG.registration_error' });
			throw (err);
		});
	}

	sendInvitation($storage, loyaltyClub, _payload) {
		this.loyaltyClub = loyaltyClub;
		let payload = _.pick(this.customer, ["customerId"]);
		return this.post('/pos/resend-invitation', payload).then(res => {
			if (res.IsSuccess) {
				this.customer.requiereInvitation = true;
			} else {
				throw ({
					message: res.Message
				});
			}
		}).catch(err => {
			throw (err);
		});
	}

	registerUpdate($storage, loyaltyClub, _payload) {
		this.loyaltyClub = loyaltyClub;
		let payload = _.assignIn(this.prepareRegistrationPayload(_payload), {
			'customerId': this.customer.customerId,
			"IsFilledJoinForm": 1,
			"IsConfirmSms": 1
		});
		return this.put('/pos/update-customer', payload).then(res => {
			if (res.IsSuccess) {
				this.prepareLoyaltyLoginResponse($storage, res);
			} else {
				throw ({
					message: res.Message
				});
			}
		}).catch(err => {
			throw (err);
		});
	}

	getRegistrationInfo($storage) {
		let that = this, club = this.loyaltyClub;
		return Promise.resolve().then(() => {
			if (club.regInfo) return club.regInfo;
			return that.httpGet('/pos/get-registration-info-v2').then(res => {
				res = _.get(res, 'ResponseData.configurations');
				if (!res) throw (null);

				let response = {
					...res.registrationInfo, ...res.cardType, ...{
						joinFormFields: res.joinFormFields || [], optionalFields: [], requiredFields: [
							{ fieldName: "FirstName", isRequired: true }, { fieldName: "LastName", isRequired: true }
						]
					}
				};
				const supportedFields = ['Email', 'Zehut', 'BirthDate', 'Anniversary']; //'FirstName', 'LastName'
				response.joinFormFields.forEach(field => {
					if (!supportedFields.includes(field.fieldName)) return;
					if (field.isRequired) response.requiredFields.push(field);
					else response.optionalFields.push(field);
				});

				this.fixResponseObject(response);

				const decimalFormat = ['US', 'AU'].includes(this.appService.region) ? '0.2-2' : '0.0-0';
				const props = response.isPayToJoin ? ['membershipItems', 'renewItems'] : ['renewItems'];
				_.each(props, prop => {
					if (!_.get(res, `${prop}.offers[0]`)) return;
					let was = false;
					_.each(res[prop].offers, offerId => {
						let offer = _.find($storage.catalog.offers, { _id: offerId });
						if (!offer) return;
						let price = _.find($storage.catalog.prices, { "offer": offerId, menu: offer.menu });
						if (!price) return;
						response[`${prop}_price`] = (price.price / 100);
						was = true;
						return false;
					});
					switch (prop) {
						case 'membershipItems':
							if (!was) {
								if (!club.disableRegistration) club.wasEnabledRegistration = true;
								club.disableRegistration = true;
							} else {
								response.clubRegMessage = this.appService.translate("_LOYALTY_REG.regPaySuccesComment", { price: this.appService.parseCurrency(String(response.membershipItems_price), decimalFormat) });
								response.clubPromptPriceMessage = this.appService.translate("_LOYALTY_REG.regPromptPrice", { price: this.appService.parseCurrency(String(response.membershipItems_price), decimalFormat) });
							}
							break;
						case 'renewItems':
							if (!was) club.disableRenew = true;
							else {
								response.clubRenewMessage = this.appService.translate("_LOYALTY_REG.loginPayExpiredComment", { price: this.appService.parseCurrency(String(response.renewItems_price), decimalFormat) });
							}
							break;
					}
				});

				//if (!response.termsFile && this.appService.appConfig.isLocal) response.termsFile = 'http://ori.com';
				if (!response.termsFile) club.disableRegistration = true;
				club.regInfo = response;
				//if (service.$storage.region == 'US') club.pointOnly = true;
			})
		}).catch(err => {
			club.disableRegistration = true;
			club.regInfo = {}
		});
	}

	getCustomer($storage, loyaltyClub, query, pincode?) {
		this.loyaltyClub = loyaltyClub;
		return this.getRegistrationInfo($storage).then(() => {
			return this.post('/pos/get-customer', {
				query: query,
				pincode: pincode,
				showAllBenefits: true,
				orderId: $storage.orderId,
				orderType: "OTC",
				serviceType: this.tdServiceTypeMap[$storage.orderMode],
			})
		}).then(res => {
			if (res.IsSuccess) {
				this.prepareLoyaltyLoginResponse($storage, res);

			} else {
				throw ({
					message: res.Message
				});
			}
		}).catch(err => {
			console.error(err);
			if (err.error) err = err.error;
			throw (err);
		});
	}

	prepareLoyaltyLoginResponse($storage, res) {
		let loyaltyMember = this.prepareLoyaltyMember($storage, res.ResponseData);
		this.prepareLoyaltyData($storage, res.ResponseData);
		this.loyaltyData = res.ResponseData;
		this.loyaltyMember = loyaltyMember;

		const pointsStoreVisible = this.loyaltyData?.balance?.visibility?.pointsStoreVisible;
		const pointsStoreId = this.loyaltyData?.customer?.pointStoreId;

		this.loyaltyData.pointsNickName = this.loyaltyData.configurations?.accountSettings?.pointsNickName;

		$storage.pointsIcon = this.loyaltyData.configurations?.accountSettings?.pointsIcon;
		$storage.pointsCaption = _.get(this.loyaltyData, 'pointsNickName', this.appService.translate('_LOYALTY.use_points'));

		if (pointsStoreVisible && pointsStoreId) {
			const pointsStoreBalance = this.loyaltyData?.balance?.pointsStorePoints;
			if (pointsStoreBalance) this.getPointStore($storage, pointsStoreBalance);
		}
		this.customer = this.loyaltyData.customer || {};
		this.appService.$storage.hasLoyalty = this.customer;
		this.cacheLoyalty();
	}

	prepareLoyaltyMember($storage, loyaltyData) {
		let that = this;
		let autoBenefits = [], manualBenefits = [], hasBenefits = false;
		loyaltyData.benefits = _.filter(loyaltyData.benefits, benefit => {
			if (!that.calculateBenefitOffers($storage, benefit)) return false;
			if (benefit.redeemInfo.isManualRedemption) {
				manualBenefits.push(benefit);
				hasBenefits = true;
			} else {
				autoBenefits.push(benefit);
				hasBenefits = true;
			}
		});

		let loyaltyMember:any = {
			workFlow: _.get(loyaltyData, 'customer.workflow'),
			loyaltyId: _.get(loyaltyData, 'customer.cardNumber'),
			points: _.get(loyaltyData, 'balance.points', 0),
			club: this.loyaltyClub._id,
			identification: {
				value: _.get(loyaltyData, 'customer.cardNumber'),
				method: "cardNum"
			},
			name: _.get(loyaltyData, 'customer.fullName'),
			printMessage: _.get(loyaltyData, 'customer.PrintMessage'),
			$maxManualBenfits: _.get(loyaltyData, 'configurations.accountSettings.limitManualRedeemBenefit', 1000),
			offers: null,
			hasBenefits: hasBenefits
		}

		if (autoBenefits[0]) loyaltyMember.$autoBenefits = autoBenefits;
		if (manualBenefits[0]) {
			loyaltyMember.$manualBenefits = manualBenefits;
			loyaltyMember.$manualBenefits_limit = manualBenefits.filter(o => o.redeemInfo?.isUnderGeneralRedeemLimit);
			loyaltyMember.$manualBenefits_unlimit = manualBenefits.filter(o => !o.redeemInfo?.isUnderGeneralRedeemLimit);
		}

		let offerIds = [], offerMessage;
		switch (loyaltyMember.workFlow) {
			case "MustPayMembershipFee":
				offerMessage = "_LOYALTY_REG.regPaySuccesComment";
				offerIds = _.get(loyaltyData, 'configurations.membershipItems.offers', []);
				break;
			case "CustomerExpired":
				offerMessage = "_LOYALTY_REG.loginPayExpiredComment";
				offerIds = _.get(loyaltyData, 'configurations.renewItems.offers', []);
				break;
			case "ExpiredSoon":
				offerMessage = "_LOYALTY_REG.expired_soon";
				offerIds = _.get(loyaltyData, 'configurations.renewItems.offers', []);
				break;
		}

		if (offerIds.length) {
			let members: any = [], membersPrice: number = 0;
			loyaltyMember.requiereOffers = true;
			_.each(offerIds, offerId => {
				let offer = _.find($storage.catalog.offers, { _id: offerId });
				if (!offer) return false;
				let price: any = _.find($storage.catalog.prices, { "offer": offerId, menu: offer.menu });
				if (!price) return false;
				let member: any = {
					offer: offerId,
					menu: offer.menu,
					name: offer.name,
					isLoyaltyOffer: true
				}
				that.orderUtils.prepareViewItem($storage.catalog, member);
				if (member._disabled) return false;
				this.orderUtils.prepareSelectItem($storage.catalog, member);
				member.total = member.price;
				membersPrice += member.price;
				member.quantity = 1;
				members.push(member);
				return false;
			});
			if (!members.length) {
				if (loyaltyMember.workFlow === 'ExpiredSoon') {
					loyaltyMember.workFlow = "none";
					return loyaltyMember;
				} else throw ({
					type: 'missing_offers',
					message: '_LOYALTY_REG.missing_offers_error'
				});
			}
			const decimalFormat = ['US', 'AU'].includes(this.appService.region) ? '0.2-2' : '0.0-0';
			if (loyaltyMember.workFlow === 'ExpiredSoon') {
				loyaltyMember.expiredSoonOffersMessage = this.appService.translate(offerMessage, {
					price: this.appService.parseCurrency(String(membersPrice), decimalFormat),
					date: moment(loyaltyData.customer.customerMembershipExpire).format(this.appService.regionArgs.dateFormat)
				});
				loyaltyMember.renewOffers = members;
			} else {
				loyaltyMember.requiereOffersMessage = this.appService.translate(offerMessage, { price: this.appService.parseCurrency(String(membersPrice), decimalFormat) });
				loyaltyMember.offers = members;
			}
		}
		return loyaltyMember;
	}

	loadingBenefits: boolean = false;
	offerBenefits: any = { }
	getBenefits(_storage, refreshCustomer = false) {
		let that = this;
		this.loadingBenefits = false;
		if (!this.loyaltyData) return Promise.resolve(null);

		this.getSelectedManualBenfitsCount(_storage);
		let order = this.getPreparedOrder_forloyalty(_storage)
		let benefitsToRedeem = this.getBenefitsToRedeem_forLoyalty(_storage, order);

		this.loadingBenefits = true;
		return this.post('/pos/get-benefits', {
			customer: {
				cardNumber: _.get(this.loyaltyData,'customer.cardNumber')
			},
			order: order,
			includeBenefitToRedeem: true,
			benefitsToRedeem: benefitsToRedeem
		}).then(res => {
			if (res.IsSuccess) {
				if (refreshCustomer) this.prepareLoyaltyLoginResponse(_storage, res);

				this.prepareLoyaltyData(_storage, res.ResponseData);
				this.loyaltyData = res.ResponseData;
				let benefitRows = res.ResponseData.orderBenefits?.byRows
				if (benefitRows) {
					benefitRows.forEach(brow => {
						let basketRow = _storage.basket.find(o => o.indexes && o.indexes.includes(brow.index));
						if (basketRow) {
							let browBenefits = brow.discounts;
							browBenefits.forEach(o => { o.quantity = 1 });
							if (!basketRow.loyaltyBenefits) {
								basketRow.loyaltyBenefits = browBenefits;
							} else {
								browBenefits.forEach(browBenefit => {
									let match = basketRow.loyaltyBenefits.find(o => o.externalSaleId == browBenefit.externalSaleId);
									if (!match) basketRow.loyaltyBenefits.push(browBenefit);
									else ++match.quantity;
								})
							}
						}
					});
				}
				this.loyaltyMember.benefitsToRedeem = _.get(res.ResponseData, 'benefitsToRedeem', benefitsToRedeem);
				this.cacheLoyalty();
			} else {
				throw ({
					message: res.Message
				});
			}
		}).catch(err => {
			console.error(err);
			delete this.loyaltyMember.benefitsToRedeem;
			delete this.loyaltyData.reference;
			delete this.loyaltyData.orderBenefits;
			this.loyaltyData.hasLoyaltyRewards = false;
			this.loyaltyData.hasBenefits = false;
			this.loyaltyData.totalBenefits = 0;
			let message = _.get(err, 'error.Message', err.message);
			switch (err?.error?.Key) {
				case "MinimumOrderRequired":
					message = this.appService.translate('_LOYALTY.minimum_order_required_message', { total: err?.error?.ResponseData?.totalOrderAfterBenefits || 0, amount: err?.error?.ResponseData?.minimumOrderAmount || 0, currency: this.appService.currency, currency1: this.appService.currency });
					return this.handleConditionalBenfitError(_storage, message);
			}
			this.appService.alert({ content: message || '_LOYALTY.member_not_found', width: 600 });
			throw (err);
		}).then(res => {
			this.loadingBenefits = false;
		});
	}

	handleConditionalBenfitError(_storage, message) {
		return new Promise((resolve, reject) => {
			this.appService.confirm({
				content: message || '_LOYALTY.member_not_found',
				width: 600,
				cancelText: this.appService.translate('_LOYALTY.cancel_benefits'), //"onChange('edit_benefits')"
				confirmText: this.appService.translate('_LOYALTY.back_to_menu') //"onChange('back_to_menu')"
			}).then((a) => {
				reject({ action: 'back_to_menu' });
			}).catch((b) => {
				this.clearBenefits(_storage);
				resolve(this.getBenefits(_storage));
			});
		});
	}

	clearBenefits(_storage) {
		_.get(_storage, 'basket', []).forEach(offer => {
			delete offer._reserved;
		});
		this.loyaltyMember.$manualBenefits?.forEach(benefit => {
			if (benefit.active) {
				benefit.active = false;
			}
		});
		this.getSelectedManualBenfitsCount(_storage);
	}

	getBenefitName(benefitId) {
		let target = this.loyaltyMember.$manualBenefits;
		if (target) {
			const benefit = _.find(target, { id: benefitId });
			if (benefit) return benefit.name;
		}
		return "unknown";
	}

	getBenefitsToRedeem_forLoyalty(_storage, preparedOrder) {
		let benefitsToRedeem = [];
		let orderOffers = _.cloneDeep(preparedOrder.offers);

		_.each(this.loyaltyMember.$manualBenefits, benefit => {
			if (!benefit.active) return;
			let benefitToRedeem = {
				"id": benefit.id,
				"externalSaleId": benefit.externalSaleId,
				"requiredPurchase": benefit.requiredPurchase ? true : false,
				"offers": []
			}
			if (_.get(benefit, 'redeemInfo.parsedOffers[0]') && benefit.redeemInfo.numberOfOffersToSelect) {
				benefitToRedeem.offers = orderOffers.filter(o => o._reserved == benefit.id).map(orderOffer => {
					return {
						"offerId": orderOffer.offerId,
						"price": orderOffer.price,
						"index": orderOffer.index
					}
				});
				if (benefitToRedeem.offers.length != benefit.redeemInfo.numberOfOffersToSelect) return;
			}
			benefitsToRedeem.push(benefitToRedeem);
		});

		_.each(_storage.basket, basketOffer => {
			delete basketOffer.loyaltyBenefits;
			let externalSaleId = basketOffer._reserved?.externalSaleId;
			if (externalSaleId) {
				let count = basketOffer._reserved.quantity;
				//basketOffer.indexes = [];
				_.forEach(orderOffers, lOffer => {
					if (!count || lOffer._bid != basketOffer._bid) return;
					let benefitToRedeem = {
						externalSaleId: externalSaleId,
						requiredPurchase: true,
						offers: [{
							offerId: lOffer.offerId,
							price: lOffer.price,
							index: lOffer.index
						}]
					}
					benefitsToRedeem.push(benefitToRedeem);
					--count;
				});
			}
		});
		return benefitsToRedeem;
	}

	signOut(_storage?) {
		_storage.loyaltyOffersMap = null;
		_.get(_storage, 'basket', []).forEach(offer => {
			delete offer._reserved;
			delete offer.loyaltyBenefits;
		});
		this.cancelBenefitsServer(_storage);
		this.init();
		return Promise.resolve(null);
	}

	cancelBenefitsServer(_storage?) {
		let	loyaltyReferenceId = _.get(this.loyaltyData, 'reference.loyaltyReferenceId');
		if (!loyaltyReferenceId) return;
		_.unset(this.loyaltyData, 'reference.loyaltyReferenceId');

		return this.post('/pos/cancel-order', {
			loyaltyReferenceId: loyaltyReferenceId,
			orderId: _storage && _storage.orderId,
			cardNumber: _.get(this.loyaltyMember,'loyaltyId')
		}).then(res => {
			return true;
		}).catch(err => {
			console.error(err);
		});
	}

	//------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------->

	getPointStore($storage, pointsStoreBalance) {
		let that = this;
		return this.httpGet('/pos/points-store/content').then(res => {
			let categories = [],
				maxPoints = this.loyaltyData?.balance?.pointsStorePoints,
				pointsDisabled = this.loyaltyData?.balance?.visibility?.pointsDisabled == true;
			let offersMap: any = {}
			_.forEach(_.get(res, 'ResponseData.pointStoreList'), psl => {
				_.forEach(psl.categories, category => {
					const cat = {
						externalSaleId: category.externalSaleId,
						accountId: category.accountId,
						sellPrice: category.sellPrice,
						caption: category.header
					}

					if (category.isOpenForSale && category.itemsConfiguration) {
						let foundOffers = that.getItemsConfiguration_offers($storage, category.itemsConfiguration);
						if (foundOffers.length) {
							foundOffers.forEach(offer => {
								if (!offersMap[offer._id]) {
									offersMap[offer._id] = {
										_id: offer._id,
										name: offer.name,
										price: cat.sellPrice,
										category: cat
									}
								}
							});
							category.foundOffers = foundOffers;
						} else {
							category._disabled = true;
						}
						categories.push(category);
					}
				});
			});
			if (Object.keys(offersMap).length) {
				offersMap._balance = pointsStoreBalance;
				offersMap.remainingUses = pointsStoreBalance;
				offersMap._used = 0;
				$storage.loyaltyOffersMap = offersMap;
				offersMap.maxUses = _.get(this.loyaltyMember, '$maxManualBenfits', 100);
				offersMap.uses = 0;
				offersMap.enabled = true;
				offersMap.disabled = pointsDisabled;

				this.getSelectedManualBenfitsCount($storage);
			}
			return offersMap;
		});
	}

	onAddToBasket($storage) {
		if (!this.loyaltyMember) return;
		if ($storage.loyaltyOffersMap) this.getSelectedManualBenfitsCount($storage);
	}

	getSelectedManualBenfitsCount($storage) {
		if (!this.loyaltyMember) return;
		let count = _.filter(this.loyaltyMember.$manualBenefits, o => o.active && o.redeemInfo?.isUnderGeneralRedeemLimit).length;
		let points = 0;
		_.each($storage.basket, basketOffer => {
			let externalSaleId = basketOffer._reserved?.externalSaleId;
			if (externalSaleId && basketOffer._reserved.quantity) {
				count += basketOffer._reserved.quantity;
				points += basketOffer._reserved.points;
			}
		});
		let storeMap = $storage.loyaltyOffersMap;
		if (storeMap) {
			storeMap.uses = count;
			storeMap.pointsUsed = points;
			storeMap.remainingPoints = storeMap._balance - storeMap.pointsUsed;
			storeMap.remainingUses = storeMap.maxUses - count;
			storeMap.enabled = storeMap.remainingUses > 0 && storeMap.remainingPoints > 0;
		}
		return count;
	}

	getItemsConfiguration_offers($storage, offersConfig) {
		let iOffers = _.get(offersConfig, 'included.offer', []),
			eOffers = _.get(offersConfig, 'excluded.offer', []),
			iMenus = _.get(offersConfig, 'included.menu', []),
			eMenus = _.get(offersConfig, 'excluded.menu', []),
			iSections = _.get(offersConfig, 'included.section', []),
			eSections = _.get(offersConfig, 'excluded.section', []);

		let catOffers = _.get($storage.catalog, 'offers', []), foundOffers = [];
		catOffers.filter(offer => {
			if (iOffers.includes(offer._id) || iMenus.includes(offer.menu) || iSections.includes(offer.section)) {
				if (!eOffers.includes(offer._id) && !eMenus.includes(offer.menu) && !eSections.includes(offer.section)) {
					if (_.find(foundOffers, { _id: offer._id })) {  }
					else foundOffers.push(offer);
				}
			}
		});
		return foundOffers;
	}

	removeSingleBenfitFromOffer($storage, offer) {
		if (offer._reserved?.externalSaleId) {
			let benefitQ = offer._reserved.quantity;
			if (offer.quantity > benefitQ) { }
			else if (benefitQ > 1) {
				offer._reserved.quantity = benefitQ - 1;
				offer._reserved.points -= offer._reserved.sellPrice;
			} else {
				delete offer._reserved;
			}
			this.getSelectedManualBenfitsCount($storage);
		}
	}

	cancelBenefitFromOffer($storage, benefitId) {
		let target = this.loyaltyMember?.$manualBenefits;
		if (target) {
			let benefit = _.find(target, { id: benefitId });
			if (benefit) this.cancelSelectedBenefit($storage, benefit);
		}
	}
	cancelSelectedBenefit($storage, benefit) {
		benefit.active = false;
		$storage.basket.forEach(offer => {
			if (offer._reserved?.benefitId == benefit.id) delete offer._reserved;
		});
		this.getSelectedManualBenfitsCount($storage);
	}


	//------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------->

	calculateBenefitOffers($storage, benefit) {
		if (!benefit.redeemInfo) {
			benefit.redeemInfo = { isManualRedemption: false }
		}
		let offersConfig = benefit.redeemInfo.itemsConfiguration;
		if (offersConfig) {
			let iOffers = _.get(offersConfig, 'included.offer', []),
				eOffers = _.get(offersConfig, 'excluded.offer', []),
				iMenus = _.get(offersConfig, 'included.menu', []),
				eMenus = _.get(offersConfig, 'excluded.menu', []),
				iSections = _.get(offersConfig, 'included.section', []),
				eSections = _.get(offersConfig, 'excluded.section', []);

			let catOffers = _.get($storage.catalog, 'offers', []), foundOffers = [];
			catOffers.filter(offer => {
				if (iOffers.includes(offer._id) || iMenus.includes(offer.menu) || iSections.includes(offer.section)) {
					if (!eOffers.includes(offer._id) && !eMenus.includes(offer.menu) && !eSections.includes(offer.section)) {
						if (_.find(foundOffers, { _id: offer._id })) {  }
						else foundOffers.push(offer);
					}
				}
			});
			if (!foundOffers.length) return false;
			benefit.redeemInfo.parsedOffers = foundOffers;
		}
		return benefit;
	}

	prepareLoyaltyData($storage, data) {
		if (!data) return;
		let that = this;
		//_.unset(this.loyaltyData.customer, 'mobile');
		if (!data.customer.mobile) {
			data.$isVoucher = true;
			data.$cPrompt = this.appService.translate("_LOYALTY.my_benefits")
		} else {
			data.$cPrompt = _.get(data.customer, 'firstName', this.appService.translate("_LOYALTY.my_benefits"))
		}

		_.each(data.benefits, benefit => {
			if (benefit.punchCardStatus || benefit.value || benefit.expired) {
				benefit.$hasValue = true;
			}
		});

		let balance = data.balance = _.assignIn({
			points: 0,
			moneyCompensation: 0,
			redeemablePoints: 0,
			prePaid: 0,
			pointsStorePoints: 0,
			visibility: {
				pointsVisible: false,
				pointsDisabled: false,
				compsVisible: false,
				pointsStoreVisible: true,
				prepaidVisible: false
			}
		}, data.balance);

		if (balance.redeemablePoints) {
			data.pontsBalance = balance.redeemablePoints;
			data.hasPoints = true;
			data.pointsUsed = 0;
			data.pointsUsable = !data.balance?.visibility?.pointsDisabled;
		}
		let totalBenefits = _.get(data, 'orderBenefits.totalDiscount');
		if (totalBenefits) {
			data.totalBenefits = totalBenefits;
			data.hasBenefits = true;
		}
		data.hasLoyaltyRewards = data.hasBenefits || data.hasPoints;
	}

	getPrepayedAccount($storage) {
		const prepayed = this.loyaltyData?.balance?.prePaid;
		if (!prepayed || !this.loyaltyData?.balance.visibility?.prepaidVisible) return;
		if (!this.loyaltyClub) return;
		const giftCardAccounts = $storage.giftCardAccounts;
		if (!giftCardAccounts) return;
		const accountGuid = (this.loyaltyClub.providerData?.accountGuid || "").toUpperCase();
		const account = giftCardAccounts.find(o => o.loyaltyApiKey?.toUpperCase() === accountGuid);
		if (account && this.customer?.cardNumber) {
			return {
				_id: account._id,
				loyaltyApiKey: account.loyaltyApiKey,
				cardNumber: this.customer.cardNumber,
				name: this.appService.translate('_GIFTCARD.loyalty_account_name', { v: account.name }),
				balance: prepayed,
				isPrepayAccount: true
			}
		}
	}

	hasPromotions() {
		return this.loyaltyData && (this.loyaltyData.hasPoints || this.loyaltyData.hasBenefits);
	}

	calculateBenefits() {
		return _.get(this.loyaltyData, 'totalBenefits', 0);
	}

	calculateTotal() {
		if (!this.hasPromotions) return 0;
		let data = this.loyaltyData;
		return _.get(data, 'pointsUsed', 0) + _.get(data, 'totalBenefits', 0);
	}

	prepareRosOrder(order, _storage, memberOnly?) {
		let data = this.loyaltyData;
		if (data && data.reference && this.loyaltyMember) {
			let member = _.cloneDeep(this.loyaltyMember);
			delete member.offers;
			delete member.printMessage;
			member.reference = this.loyaltyData.reference;
			order.member = _.assignIn(_.pick(this.loyaltyMember, ['loyaltyId', 'club', 'identification', 'name', 'printMessage', 'points']), { "reference": data.reference });;
		}
		if (!this.hasPromotions() || memberOnly) return;
		let promotions = [], promotion;
		let rewards = [];
		let amount = _.get(data, 'totalBenefits', 0), amountCents = Math.round(amount * 100);
		if (amount > 0) {
			promotion = {
				"_id": this.getObjectId(),
				"promotion": this.loyaltyClub.generalPromotion,
				"promotionType": "generalDiscount",
				"club": this.loyaltyClub._id,
				"pointsUsed": 0,
				"targets": [],
				"suggestedAmount": amountCents,
				"providerInfo": {
					"transactionId": _.get(data, 'reference.loyaltyReferenceId')
				}
			};
			promotions.push(promotion);
			rewards.push({
				_type: "AmountOffOrder",
				promotion: promotion._id,
				manual: true,
				//name: "string",
				discount: {
					amount: amountCents,
					amountOff: amountCents,
				}
			});

		}
		if (data.hasPoints && data.pointsUsed) {
			amount = data.pointsUsed;
			amountCents = Math.round(amount * 100);
			promotion = {
				"_id": this.getObjectId(),
				"promotion": this.loyaltyClub.pointsPromotion,
				"promotionType": "pointsDiscount",
				"club": this.loyaltyClub._id,
				"pointsUsed": amount,
				"targets": [

				],
				"suggestedAmount": amountCents,
				"providerInfo": {
					"transactionId": _.get(data, 'reference.loyaltyReferenceId')
				}
			};
			promotions.push(promotion);
			rewards.push({
				_type: "AmountOffOrder",
				promotion: this.loyaltyClub.pointsPromotion,//promotion._id,
				manual: true,
				//name: "string",
				discount: {
					amount: amountCents,
					amountOff: amountCents,
				}
			});
		}
		if (promotions.length) {
			if (!order.rewards) order.rewards = [];
			order.rewards = order.rewards.concat(rewards);
			order.orderedPromotions = promotions;

			let manualBenefits = this.loyaltyMember.$manualBenefits, benefitsToRedeem;
			if (manualBenefits) benefitsToRedeem = _.filter(manualBenefits, _benefit => _benefit.active);
			if (benefitsToRedeem) order.member.benefitsToRedeem = this.loyaltyMember.benefitsToRedeem;
		}
	}

	getPreparedOrder_forloyalty(_storage, options?) {
		let that = this;
		if (!_storage.orderId) _storage.orderId = that.getObjectId();
		_storage.offerIndex = 0;

		let order = _storage.order;
		options = options || {};

		let ret: any = {
			"organization": _storage.config.id,
			"orderId": _storage.orderId,
			"orderNumber": undefined,
			"waiterName": undefined,
			"orderType": "OTC",
			"serviceType": this.tdServiceTypeMap[_storage.orderMode],
			"numberOfDiners": 1,
			"tableNumber": undefined,
			"offers": []
		}

		if (order.promotion && order.promotion.calc) {
			if (order.promotion.valueType == 'amount') {
				ret.orderDiscountAmount = order.promotion.value;
			} else {
				ret.orderDiscountPercent = order.promotion.value;;
			}
		}
		//start basket
		_.each(_storage.basket, function (offer) {

			delete offer.$startIndex;
			delete offer.$endIndex;

			let offerPrice = offer.price;
			var q = offer.quantity || 1;
			let startOfferIndex = _storage.offerIndex + 1;

			let _reserved = offer._reserved?.benefitId;

			offer.indexes = [];
			for (var i = 0; i < q; i++) {
				let parsedOffer: any = {
					"_bid": offer._bid,
					"_reserved": _reserved,
					"index": ++_storage.offerIndex,
					"price": offerPrice,
					"qty": 1,
					"offerId": offer.offer,
					"offerName": offer.realName || offer.name,
					"menuId": offer.menu,
					"menuName": undefined,
					"sectionId": offer._offer.section,
					"sectionName": offer._offer.sectionName,
					"items": []
				}

				offer.indexes.push(parsedOffer.index);

				// main offer item
				if (offer._item) {
					prepareBasketOfferItem(offer._item, offer._item.total, parsedOffer);
				}

				_.each(offer.selectionSummary, function (selectionGroup) {
					_.each(selectionGroup.items, function (item) {
						let count = item.count || 1
						for (let i = 0; i < count; i++) {
							let _itemTotal = item.price;
							prepareBasketOfferItem(item._item, _itemTotal, parsedOffer);
						}
					});
				});


				offer.$startIndex = startOfferIndex;
				offer.$endIndex = _storage.offerIndex
				if (offerPrice || parsedOffer.items.length) ret.offers.push(parsedOffer);
			}


			function prepareBasketOfferItem(item, itemPrice, parsedOffer) {
				if (itemPrice) {
					let pitem = {
						"index": ++_storage.offerIndex,
						"price": itemPrice || 0,
						"qty": 1,
						"itemId": item._id,
						"itemName": item.realName || item.name,
						//"menuId": parsedOffer.menuId,
						"menuName": parsedOffer.menuName,
						//"sectionId": parsedOffer.sectionId,
						"sectionName": parsedOffer.sectionName
					}
					parsedOffer.items.push(pitem);
				}

				_.each(item.modifierGroups, (group) => {
					if (!group.singleSelection) {
						_.each(group.modifiers, (mod) => {
							if (mod.formationUnit && mod.price && mod.item) {
								let moditem = {
									"index": ++_storage.offerIndex,
									"price": mod.price || 0,
									"qty": 1,
									"itemId": mod.item,
									"itemName": mod.name,
									//"menuId": parsedOffer.menuId,
									"menuName": parsedOffer.menuName,
									//"sectionId": parsedOffer.sectionId,
									"sectionName": parsedOffer.sectionName
								}
								parsedOffer.items.push(moditem);
							}
						});
					}
				});
			}

		});
		return ret;
	}

	getObjectId() {
		let timestamp = (new Date().getTime() / 1000 | 0).toString(16);
		return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
			return (Math.random() * 16 | 0).toString(16);
		}).toLowerCase();
	}

	// ----------------------------------------------------------------------------------------------------------->

	getLoyaltyHeaders() {
		return {
			headers: new HttpHeaders({
				'Authorization': this.authService.appHttpOptions.headers.get("Authorization"),
				'env': this.appConfig.loyaltyEnv ,
				'JoinChannelGuid': this.appConfig.loyaltyJoinChannelGUID,
				'accountGuid': this.loyaltyClub.accountGuid,
				'siteId': this.appService.getOrganization()
			})
		}
	}

	public post(url, payload?, _headers?): Promise<any> {
		return new Promise((resolve, reject) => {
			this.httpClient.post(this.appConfig.tabitLoyaltyAPI + url, payload || {}, this.getLoyaltyHeaders() || this.authService.appHttpOptions)
				.subscribe(
					(results: any) => {
						resolve(results);
					},
					(err) => {
						reject(err);
					}
				);
		});
	}

	public put(url, payload?, _headers?): Promise<any> {
		return new Promise((resolve, reject) => {
			this.httpClient.put(this.appConfig.tabitLoyaltyAPI + url, payload || {}, this.getLoyaltyHeaders() || this.authService.appHttpOptions)
				.subscribe(
					(results: any) => {
						resolve(results);
					},
					(err) => {
						reject(err);
					}
				);
		});
	}

	public httpGet(url, payload?, _headers?): Promise<any> {
		let headers;
		return new Promise((resolve, reject) => {
			let params = _.assignIn({}, this.getLoyaltyHeaders(), { params: payload });
			if (headers) {
				_.each(params.headers.keys(), key => {
					headers[key] = params.headers.get(key);
				});
				params.headers = headers;
			}
			this.httpClient.get(this.appConfig.tabitLoyaltyAPI + url, params )
				.subscribe(
					(results: any) => {
						resolve(results);
					},
					(err) => {
						reject(err);
					}
				);
		});
	}

	public remove(url, payload?, headers?): Promise<any> {
		this.authService.appHttpOptions.headers = this.authService.appHttpOptions.headers.set("accountGuid", this.loyaltyClub.accountGuid);
		let params = _.assignIn({}, this.authService.appHttpOptions, { params: payload });
		if (headers) {
			_.each(params.headers.keys(), key => {
				headers[key] = params.headers.get(key);
			});
			params.headers = headers;
		}

		return new Promise((resolve, reject) => {
			this.httpClient.delete(this.appConfig.tabitLoyaltyAPI + url, params)
				.subscribe(
					(results: any) => {
						resolve(results);
					},
					(err) => {
						reject(err);
					}
				);
		});
	}


}
